import React from 'react';
import { useNetworkStatus } from '../utils/offlineUtils';

const OfflineIndicator: React.FC = () => {
  const { isOffline } = useNetworkStatus();

  if (!isOffline) {
    return null;
  }

  return (
    <div className="offline-indicator">
      <div className="offline-indicator-content">
        <span className="offline-icon">📱</span>
        <span className="offline-text">Vanlyn - Speel steeds!</span>
      </div>
    </div>
  );
};

export default OfflineIndicator;